// extracted by css-extract-rspack-plugin
export default {"LoginForm":"LoginForm-rOKv7I","loginForm":"LoginForm-rOKv7I"};